import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, DownloadIcon, MonitorSmartphoneIcon } from 'lucide-react';
const formatItems = [{
  text: 'Ebook digital',
  icon: BookOpenIcon
}, {
  text: 'Descarga inmediata',
  icon: DownloadIcon
}, {
  text: 'Compatible con celular, tablet y computadora',
  icon: MonitorSmartphoneIcon
}];
export function FormatSection() {
  return <section className="py-28 md:py-32 px-4 relative overflow-hidden border-t border-[#E8E1D5]" data-id="element-100">
      {/* Background Image */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-101">
        <img src="https://cdn.magicpatterns.com/uploads/uB9ZY93CBEJB5usPDQ2AUv/13_mar_2026,_11_51_55_p.m..png" alt="" className="w-full h-full object-cover" data-id="element-102" />
        <div className="absolute inset-0 bg-white/80" data-id="element-103"></div>
      </div>
      <div className="max-w-4xl mx-auto" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-105">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif text-[#2F3A3D]" data-id="element-106">
            Formato
          </h2>
        </motion.div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-16" data-id="element-107">
          {formatItems.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="flex flex-col items-center text-center max-w-[220px]" data-id="element-108">
                <div className="w-20 h-20 rounded-full bg-[#F7F3E9] border border-[#E8E1D5] flex items-center justify-center mb-6 text-[#F4A261] shadow-sm" data-id="element-109">
                  <Icon className="w-8 h-8" data-id="element-110" />
                </div>
                <p className="text-[#5F6368] font-medium text-lg leading-relaxed" data-id="element-111">
                  {item.text}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}